import {
	FETCH_LICENSEDATA, EDIT_LICENSEDATA
} from "../actions/types";

export default (state = {}, action) => {
	switch (action.type) {
		
		case FETCH_LICENSEDATA:
			return {
				...state,
				...action.payload
			}
		case EDIT_LICENSEDATA:
			const setFields = Object.keys(action.payload).filter( key => {
				return action.payload[key] !== null
			})
			
			const setFieldsObject = {}
			setFields.forEach( key => setFieldsObject[key] = action.payload[key] )
			
			return {
				...state,
				...setFieldsObject
			}
		default:
			return state;
	}
}